class VariantDescription extends HTMLElement {
	constructor() {
		super();
		this.descriptions = {};
		this.descriptionBox = null;
		this.variantPicker = null;
	}

	connectedCallback() {
		const scriptEl = this.querySelector(".variant-descriptions");
		if (scriptEl) {
			this.descriptions = JSON.parse(scriptEl.textContent.trim());
		}

		this.descriptionBox = this.querySelector(".description-box");
		this.variantPicker = document.querySelector('[name="id"]');
		if (this.variantPicker) {
			this.variantPicker.addEventListener("change", (e) => {
				this.updateDescription(e.target.value);
			});
		}
		const initialId = this.dataset.initialVariantId;
		if (initialId) {
			this.updateDescription(initialId);
		}
	}

		updateDescription(variantId) {
		const newDescription = this.descriptions[variantId];
		if (this.descriptionBox) {
			this.descriptionBox.innerHTML = newDescription || "";
		}
	}
}
customElements.define("variant-description", VariantDescription);
